// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"183":"30c35980","406":"5509d1df","670":"9b5a2eeb","978":"62cdb187"}[chunkId] + ".chunk.js";
};